<script setup lang="ts">
import { IOpenCustomization } from '~/lib/models/events'
import { OptionsGroupsMain, productInfoKey } from '~/lib/services/store/catalog/catalog.dtos'

const props = defineProps<{
  optionGroup: OptionsGroupsMain
}>()

const emit = defineEmits<{
  (e: 'open-customization', payload: IOpenCustomization): void
}>()

const productInfo = inject(productInfoKey)!

const { t } = useLocale()
const { translateInterpolated } = useTranslation()
const { trackAdditionalComponent } = useGTM()

const customizationString = computed(() =>
  translateInterpolated(getProductCustomizationResume([props.optionGroup]))
)

const editCondimentText = computed(() => {
  if (customizationString.value) return t('productDetail.customization.actions.change')
  else return t('productDetail.customization.actions.add')
})

const openCustomization = (event: PointerEvent) => {
  emit('open-customization', {
    event,
    optionsGroups: [props.optionGroup],
    openedComponent: {
      id: props.optionGroup.identifier,
      name: props.optionGroup.title,
    },
  })
  trackAdditionalComponent(productInfo)
}
</script>

<template>
  <div class="flex flex-row items-center gap-2 pt-4">
    <div class="flex flex-1 flex-col justify-center gap-3">
      <p class="text-xs">{{ optionGroup.title }}</p>

      <!-- CONDIMENT - Personalization string -->
      <p
        v-if="customizationString"
        v-dompurify-html="customizationString"
        class="line-clamp-2 text-xs text-mcd-secondaryDarkGrey"
      ></p>
    </div>
    <McdButton
      v-if="optionGroup.options.length"
      is-secondary
      class="btn-customization"
      @on-click="($ev: PointerEvent) => openCustomization($ev)"
    >
      {{ editCondimentText }}
    </McdButton>
  </div>
</template>
